module.exports = __webpack_public_path__ + "static/Not Evil Ads Share Image-ed1528864f10b59d1fc9399f189fdb90.png";